export interface Decision {
  id: number;
  numero: string;
  juridiction: string;
  nature: string;
  parties: string;
  date: string;
  statut: 'a_verifier' | 'anonymise' | 'publie' | 'brouillon' | 'valide';
  agent: string;
}

export interface StatCard {
  label: string;
  sublabel?: string;
  value: number;
  change?: string;
  icon: string;
}

export const decisions: Decision[] = [
  { id: 1, numero: 'TPI-ABJ-2024/0123', juridiction: 'TPI Abidjan', nature: 'Bail commercial', parties: 'KOFFI c/ IVOIRE NEGOCE SA', date: '2024-03-12', statut: 'a_verifier', agent: 'A. Diallo' },
  { id: 2, numero: 'TPI-ABJ-2024/0098', juridiction: 'TPI Abidjan', nature: 'Bail commercial', parties: 'TRAORE c/ SCI HORIZON', date: '2024-02-28', statut: 'publie', agent: 'M. Konan' },
  { id: 3, numero: 'CA-ABJ-2024/0045', juridiction: "Cour d'Appel Abidjan", nature: 'Bail commercial', parties: 'Sté X c/ Sté Y', date: '2024-01-18', statut: 'publie', agent: 'M. Konan' },
  { id: 4, numero: 'TPI-BKE-2024/0212', juridiction: 'TPI Bouaké', nature: 'Divorce', parties: 'OUATTARA c/ BAMBA', date: '2024-04-02', statut: 'anonymise', agent: 'A. Diallo' },
  { id: 5, numero: 'TPI-YAM-2024/0067', juridiction: 'TPI Yamoussoukro', nature: 'Crédit bancaire', parties: 'DIABATE c/ Banque XYZ', date: '2024-04-08', statut: 'brouillon', agent: 'S. Coulibaly' },
  { id: 6, numero: 'CA-ABJ-2024/0078', juridiction: "Cour d'Appel Abidjan", nature: 'Responsabilité civile', parties: 'ASSI c/ SOTRA', date: '2024-03-22', statut: 'valide', agent: 'M. Konan' },
];

export const statsCards: StatCard[] = [
  { label: 'DÉCISIONS REÇUES (MOIS)', value: 234, change: '+18%', icon: 'file-text' },
  { label: "EN COURS D'ANONYMISATION", value: 47, sublabel: '12 prioritaires', icon: 'sparkles' },
  { label: 'À VALIDER', value: 18, sublabel: 'Superviseur', icon: 'file-check' },
  { label: 'PUBLIÉES', value: 1246, change: '+24 cette semaine', icon: 'download' },
];

export const volumeMensuel = [
  { mois: 'Oct', valeur: 120 },
  { mois: 'Nov', valeur: 155 },
  { mois: 'Déc', valeur: 140 },
  { mois: 'Jan', valeur: 165 },
  { mois: 'Fév', valeur: 190 },
  { mois: 'Mar', valeur: 234 },
];

export const parJuridiction = [
  { name: 'TPI Abidjan', value: 432, color: '#1B2A4A' },
  { name: "Cour d'Appel", value: 198, color: '#3B5998' },
  { name: 'TPI Bouaké', value: 124, color: '#F9B887' },
  { name: 'TPI Yamoussoukro', value: 86, color: '#FDDCB5' },
  { name: 'Autres', value: 64, color: '#FEF0E0' },
];

export const statutLabels: Record<string, { label: string; color: string; bg: string }> = {
  a_verifier: { label: 'À vérifier', color: '#8B6914', bg: '#FFF8E7' },
  anonymise: { label: 'Anonymisé', color: '#059669', bg: '#ECFDF5' },
  publie: { label: 'Publié', color: '#047857', bg: '#D1FAE5' },
  brouillon: { label: 'Brouillon', color: '#6B7280', bg: '#F3F4F6' },
  valide: { label: 'Validé', color: '#065F46', bg: '#A7F3D0' },
};

export const decisionDetail = {
  id: 1,
  numero: 'TPI-ABJ-2024/0123',
  juridiction: 'TPI Abidjan',
  type: 'Civil',
  date: '2024-03-12',
  nature: 'Bail commercial',
  parties: 'KOFFI c/ IVOIRE NEGOCE SA',
  agent: 'A. Diallo',
  statut: 'a_verifier' as const,
  historique: [
    { action: 'Upload', date: '2024-03-15', agent: 'A. Diallo' },
    { action: 'Anonymisation automatique', date: '2024-03-15', agent: 'Système' },
    { action: 'Résumé généré', date: '2024-03-16', agent: 'Système' },
  ],
  texteAnonymise: `Le Tribunal de Première Instance d'Abidjan, statuant publiquement et contradictoirement en matière civile, après en avoir délibéré conformément à la loi ;

Vu l'assignation introductive d'instance en date du 12 mars 2024 par laquelle Monsieur [PARTIE_1], demeurant à [LIEU_1], a assigné la Société [SOCIETE_1], sise au [LIEU_2], en paiement de la somme de [MONTANT] représentant des arriérés de loyers ;

Attendu que la défenderesse a comparu par le ministère de Maître [CONSEIL_1], avocat à la Cour ;

Sur le fond, il ressort des pièces versées au dossier que le bail commercial conclu entre les parties prévoit un loyer mensuel de [MONTANT] payable d'avance ;

Par ces motifs, le Tribunal condamne la Société [SOCIETE_1] à payer à Monsieur [PARTIE_1] la somme de [MONTANT].`,
  texteOriginal: `Le Tribunal de Première Instance d'Abidjan, statuant publiquement et contradictoirement en matière civile, après en avoir délibéré conformément à la loi ;

Vu l'assignation introductive d'instance en date du 12 mars 2024 par laquelle Monsieur KOFFI Jean-Baptiste, demeurant à Cocody, a assigné la Société IVOIRE NEGOCE SA, sise au Plateau, en paiement de la somme de 15 000 000 FCFA représentant des arriérés de loyers ;

Attendu que la défenderesse a comparu par le ministère de Maître YAO Akissi, avocat à la Cour ;

Sur le fond, il ressort des pièces versées au dossier que le bail commercial conclu entre les parties prévoit un loyer mensuel de 1 250 000 FCFA payable d'avance ;

Par ces motifs, le Tribunal condamne la Société IVOIRE NEGOCE SA à payer à Monsieur KOFFI Jean-Baptiste la somme de 15 000 000 FCFA.`,
  resume: "Condamnation d'une société au paiement d'arriérés de loyers commerciaux. Application stricte du contrat de bail.",
  motsCles: ['bail commercial', 'loyers impayés', 'condamnation', 'société'],
  decisionsSimlaires: [
    { numero: 'TPI-ABJ-2024/0098', juridiction: 'TPI Abidjan', nature: 'Bail commercial', similarite: 92 },
    { numero: 'CA-ABJ-2024/0045', juridiction: "Cour d'Appel Abidjan", nature: 'Bail commercial', similarite: 81 },
  ],
};

export const fileSuggestions = [
  'bail commercial loyers impayés',
  'responsabilité civile accident',
  'divorce torts exclusifs',
  'crédit bancaire consommateur',
];

// ─── Admin: Utilisateurs ───

export interface UserItem {
  id: string;
  username: string;
  email: string;
  role: 'admin' | 'agent' | 'superviseur';
  statut: 'actif' | 'inactif';
  dateCreation: string;
  derniereConnexion: string | null;
}

export const mockUsers: UserItem[] = [
  { id: '1', username: 'admin01', email: 'admin@tca.ci', role: 'admin', statut: 'actif', dateCreation: '2024-01-10', derniereConnexion: '2024-04-08' },
  { id: '2', username: 'a.diallo', email: 'a.diallo@tca.ci', role: 'agent', statut: 'actif', dateCreation: '2024-02-15', derniereConnexion: '2024-04-07' },
  { id: '3', username: 'm.konan', email: 'm.konan@tca.ci', role: 'agent', statut: 'actif', dateCreation: '2024-02-20', derniereConnexion: '2024-04-08' },
  { id: '4', username: 's.coulibaly', email: 's.coulibaly@tca.ci', role: 'agent', statut: 'inactif', dateCreation: '2024-03-01', derniereConnexion: '2024-03-15' },
  { id: '5', username: 'k.toure', email: 'k.toure@tca.ci', role: 'superviseur', statut: 'actif', dateCreation: '2024-01-20', derniereConnexion: '2024-04-06' },
  { id: '6', username: 'b.yao', email: 'b.yao@tca.ci', role: 'agent', statut: 'actif', dateCreation: '2024-03-10', derniereConnexion: '2024-04-05' },
];

export const roleLabels: Record<string, { label: string; color: string; bg: string }> = {
  admin: { label: 'Administrateur', color: '#7C3AED', bg: '#F5F3FF' },
  agent: { label: 'Agent', color: '#8B6914', bg: '#FFF8E7' },
  superviseur: { label: 'Superviseur', color: '#2563EB', bg: '#EFF6FF' },
};

export const statutUserLabels: Record<string, { label: string; color: string; bg: string }> = {
  actif: { label: 'Actif', color: '#059669', bg: '#ECFDF5' },
  inactif: { label: 'Inactif', color: '#6B7280', bg: '#F3F4F6' },
};

// ─── Admin: Historique de connexion ───

export interface LoginLog {
  id: number;
  username: string;
  email: string;
  date: string;
  heure: string;
  heureDeconnexion?: string;
  duree?: string;
  ip: string;
  appareil: string;
  resultat: 'succes' | 'echec';
  motifEchec?: string;
}

export const mockLoginLogs: LoginLog[] = [
  { id: 1, username: 'admin01', email: 'admin@tca.ci', date: '2024-04-08', heure: '08:12', heureDeconnexion: '12:45', duree: '4h 33min', ip: '192.168.1.10', appareil: 'Chrome · Windows', resultat: 'succes' },
  { id: 2, username: 'm.konan', email: 'm.konan@tca.ci', date: '2024-04-08', heure: '08:35', heureDeconnexion: '17:20', duree: '8h 45min', ip: '192.168.1.24', appareil: 'Firefox · macOS', resultat: 'succes' },
  { id: 3, username: 'a.diallo', email: 'a.diallo@tca.ci', date: '2024-04-07', heure: '17:48', heureDeconnexion: '18:30', duree: '42min', ip: '192.168.1.15', appareil: 'Chrome · Windows', resultat: 'succes' },
  { id: 4, username: 'inconnu', email: 'test@hack.com', date: '2024-04-07', heure: '14:22', ip: '41.207.98.12', appareil: 'curl · Linux', resultat: 'echec', motifEchec: 'Identifiants invalides' },
  { id: 5, username: 's.coulibaly', email: 's.coulibaly@tca.ci', date: '2024-04-07', heure: '09:10', ip: '192.168.1.30', appareil: 'Safari · iPhone', resultat: 'echec', motifEchec: 'Compte désactivé' },
  { id: 6, username: 'k.toure', email: 'k.toure@tca.ci', date: '2024-04-06', heure: '16:05', heureDeconnexion: '18:00', duree: '1h 55min', ip: '192.168.1.18', appareil: 'Chrome · Windows', resultat: 'succes' },
  { id: 7, username: 'b.yao', email: 'b.yao@tca.ci', date: '2024-04-05', heure: '11:30', heureDeconnexion: '16:15', duree: '4h 45min', ip: '192.168.1.42', appareil: 'Edge · Windows', resultat: 'succes' },
  { id: 8, username: 'admin01', email: 'admin@tca.ci', date: '2024-04-05', heure: '07:55', heureDeconnexion: '17:30', duree: '9h 35min', ip: '192.168.1.10', appareil: 'Chrome · Windows', resultat: 'succes' },
  { id: 9, username: 'a.diallo', email: 'a.diallo@tca.ci', date: '2024-04-04', heure: '13:40', ip: '10.0.0.5', appareil: 'Chrome · Android', resultat: 'echec', motifEchec: 'Mot de passe incorrect' },
  { id: 10, username: 'm.konan', email: 'm.konan@tca.ci', date: '2024-04-04', heure: '08:20', heureDeconnexion: '17:50', duree: '9h 30min', ip: '192.168.1.24', appareil: 'Firefox · macOS', resultat: 'succes' },
  { id: 11, username: 'admin01', email: 'admin@tca.ci', date: '2024-04-03', heure: '09:00', heureDeconnexion: '13:10', duree: '4h 10min', ip: '192.168.1.10', appareil: 'Chrome · Windows', resultat: 'succes' },
  { id: 12, username: 'k.toure', email: 'k.toure@tca.ci', date: '2024-04-02', heure: '15:15', heureDeconnexion: '18:45', duree: '3h 30min', ip: '192.168.1.18', appareil: 'Chrome · Windows', resultat: 'succes' },
];
